

//JobTimeLineMsg => AuditBase
export class PropertyTimeLineMsg {
  jobId: string;
  log: LogMessage[];
}

export class LogMessage {
  title: string;
  messageData: MessageData;
  time: Date;
  messageTypeEnum: MessageType;
  isNewItem: boolean;
}

export class MessageData {
  jobId: string;
  fullName: string;
  serviceProviderId: string;
  bidId: string;
  timeDuration: string;
  description: string;
  quoteType: string;
  userId: string;
  createdByUserName: string;
  createdByUserId: string;
  createdUserRole: string;
  modifiedByUserName: string;
  modifiedByUserId: string;
  jobNumber: string;
  price: string;
  serviceProviderName: string;
  email: string;
  propertyId: string;
  reccuranceType: string;
  notes: string;
  propertyName: string;
  name: string;
  title: string;
  count: string;
  organizationId: string;
  type: string;
  optionalParam: string;
  ownerName: string;
  isEmailTimeline: boolean;
  emailActivityId: string;
  emailStatus: string;
  notificationUser: string;
  emailCount: number;
  isTradePostedJob: boolean = false;
  isIncomingMail: boolean = false;
  noteTypeId: number;
  isVariationCreateByPm: boolean = false;
  isSubcontractor: boolean = false;
  tenantInvitationType : TenantTypes;
  assetName:string;
  isPmDefinedRule: boolean = false;
}

export enum MessageType {
  messageInitialized = 1,
  userRegistered = 250,
  userAcceptedTheInvitation = 260,
  userJoinedAsATradee = 270,
  userMobileVerificationSuccess = 280,
  userPasswordCreationSuccessViaEmail = 290,
  userFeedbackReceived = 300,

  chatReceivedGlobal = 401,
  chatReceivedJobSpecific = 402,
  chatReceivedPropertySpecific = 403,

  jobCreated = 601,
  jobDrafted = 602,
  jobPosted = 603,
  jobDeleted = 604,
  jobFeedBackReceived = 605,
  jobUpdated = 607,
  jobArrived = 609,
  jobQuoteReceived = 610,
  jobQuoteApproved = 611,
  jobQuoteRejected = 612,
  taskStarted = 613,
  taskPaused = 614,
  taskResumed = 615,
  taskCompleted = 617,
  jobReceivedaScheduledEvent = 618,
  jobScheduledEventTentative = 619,
  jobScheduledEventConfirmed = 620,
  jobScheduledEventCancelled = 621,
  jobVariationAdded = 622,
  jobVariationApproved = 623,
  jobVariationRejected = 624,
  jobAwarded = 625,
  jobWorkOrderSent = 626,
  jobPostedTargetTradeeNone = 627,
  jobPostedTargetTradeeNearByProviders = 628,
  jobPostedTargetTradeeMultipleInternal = 629,
  jobPostedTargetTradeeInternalExternal = 630,
  jobRelatedEmailSent = 631,
  jobNotificationSent = 632,
  jobAwaitingApproval = 633,
  jobRecurranceCreated = 634,
  taskOnTheWayStarted = 635,
  jobPendingReview = 636,
  jobPendingReviewCompleted = 637,
  jobAwaitingOwnerApproval = 638,
  jobOwnerApproved = 639,
  jobCancelled = 640,
  jobInvoiceMarkAsPaid = 641,
  jobAttachmentReceived = 642,
  jobApprovedByPM = 643,
  jobRejected = 644,
  jobOwnerRejected = 645,
  jobNotificationSentDisableSP = 646,
  jobSentForOwnerApproval = 647,
  jobScheduledEventRescheduled = 648,
  jobScheduledShared = 649,
  jobEmailSentCount = 650,
  jobNotificationsSentCount = 651,
  jobReceivedChat = 652,
  jobAcceptedQuoteAddedInitialPayment = 653,
  taskCompletedFromWeb = 654,
  jobReceivedCall = 655,
  jobAvailable = 656,
  JobNotificationsSentCountByTypes = 657,
  JobVideoMessageSent = 658,
  JobPendingReviewRejected = 659,
  jobPostedToThirdParty = 663,
  jobCloning = 666,
  jobGrouping = 667,
  jobUnGrouping = 668,
  jobGroupingUpdated = 669,
  jobAwardRejected = 670,
  jobActivated = 671,
  jobPendingInvoice = 673,
  jobPayerChanged = 675,
  jobFeedBackDrafted = 680,
  jobVariationSentForOwnerApproval = 681,
  jobVariationApprovedByOwner = 682,
  jobVariationRejectedByOwner = 683,
  jobVariationApprovedByPM = 684,
  jobVariationRejectedByPM = 685,
  TaskCheckedOut = 686,
  ProviderPostedJob = 687,
  SubcontractorPostedJob = 688,
  SpRejectSubcontractorPostedJob = 689,
  PmAcceptProviderPostedJob = 690,
  PmRejectProviderPostedJob = 691,
  SpAcceptSubcontractorPostedJob = 692,

  quoteRevisionPlaced = 701,
  quoteRevisionRequested = 702,
  quoteRevisionApproved = 703,
  quoteRevisionRejected = 704,
  quoteNotificationSent = 705,
  quoteReceivedChat = 706,
  quoteUpdateEstimate = 707,
  quoteCancelled = 708,
  quoteAddedAttachment = 709,
  quoteAddedAssignee = 710,
  jobAssigned = 711,
  jobReassigned = 712,
  JobReAwarded = 713,
  jobUnassigned = 714,

  propertyRelatedEmailSent = 801,
  propertyNotificationSent = 802,
  propertyManagerAssigned = 803,
  propertyCreated = 804,
  propertyUpdated = 805,
  propertyDeleted = 806,
  propertyOwnerCreated = 807,
  propertyOwnerUpdated = 808,
  propertyOwnerDeleted = 809,
  propertyTenantCreated = 810,
  propertyTenantUpdated = 811,
  propertyTenantDeleted = 812,
  propertyAttachmentDeleted = 813,
  propertyAttachmentAdded = 814,
  PropertyOwnerReinvited = 815,
  PropertyTenantReinvited = 816,
  PropertyManagerReinvited = 817,
  ServiceProviderReinvited = 818,
  BranchCreated = 819,
  BranchUpdated = 820,
  BranchStatusUpdated = 821,
  BranchDeleted = 822,
  PropertyManagerCreated = 823,
  PropertyManagerUpdated = 824,
  PropertyManagerSuspended = 825,
  PropertyManagerDeleted = 826,
  documentAdded = 827,
  documentDeleted = 828,

  serviceProviderNotificationReceived = 901,
  serviceProviderEmailRecevied = 902,
  serviceProviderEmailReceviedPrivate = 903,
  serviceProviderLocationConfirmed = 904,

  dispatcherTeamCreated = 905,
  dispatcherTeamUpdated = 906,
  dispatcherTeamDeleted = 907,
  dispatcherTeamAssigned = 908,
  dispatcherTeamUnassigned = 909,
  dispatcherTeamUserAssigned = 910,
  dispatcherTeamUserUnassigned = 911,
  jobAttachmentDeleted = 912,
  jobPendingAcceptance = 913,
  pmReminderForOwnerApproval = 914,
  pmReminderForOwnerApprovalQuotes = 915,
  pmReminderForPendingQuotes = 916,
  pmReminderForPendingSchedule = 917,
  pmReminderForScheduledJob = 918,
  pmReminderForPendingInvoice = 919,
  spReminderForPendingReview = 920,
  spReminderForSiteVisits = 921,
  spReminderForScheduledJob = 922,
  spReminderForVariationApproval = 923,
  timelinePropertyReport = 924,
  timelineJobReport = 925,
  organizationDisclaimerReport = 926,
  quoteReminderSent = 927,
  ownerApprovalReceived = 928,
  ownerApprovalReminderSent = 929,
  preQuoteOwnerApprovalReceived = 930,
  ownerApprovalRejected = 931,
  preQuoteOwnerApprovalRejected = 932,

  quoteJobViewedByProvider = 1024,
  awardedJobViewedByProvider = 1025,
  jobEmailSent = 1026,
  jobNote = 1100,
  ownerAttendingJobPost = 1101,
  ownerApprovedJob = 1102,
  ownerRejectedJob = 1103,
  invoiceCancelled = 1104,
  JobSwitchRequested = 1105,
  jobMerged = 1106,
  taskCompletedFromJobRule = 1107,
  taskCompletedByPm = 1108,
  jobVariationCancelled = 1109,
  tradeJobPostedAsComplete = 1110,
  spJobPostedForTheAgency = 1111,
  unableToContactTenant = 1113,
  dueDateUpdate = 1114,
  JobScheduleCanceledByServiceProvider = 1116,
  CancelQuote = 1118,
  JobQuoteDetailUpdated = 1120,
  propertyAssetAdded = 1133,
  propertyAssetUpdated = 1134,
  propertyAssetDeleted = 1135,
  AssetAssignForJob = 1141,
  SendTenatToAssetInvitationLink = 1147,
  AssetsUploadReceived = 1148,
  SendTenatToAssetLink =1150,
  groupedJobRuleReminderToTradee = 1151,
  JobDraftedBasedOnAssetRecommendation = 1159,
  AssetRecommendationRejected = 1160,
  AssetRecommendationSnooze = 1161,
  InvoiceCancellationUnsuccessful = 1163 
}

export enum TimelineView {
  NONE = 0,
  PM = 1,
  SP = 2,
  PROPERTY = 3,
  JOB = 4,
  EMAIL = 5,
}

export class TimelineRequest {
  propertyId: string | null;
  filterType: MessagesFilterType;
  pageNo: number;
  pageSize: number;
}

export enum MessagesFilterType {
  All = 0,
  Jobs = 1,
  Quotes = 2,
  Chats = 3,
  Emails = 4,
  Notifications = 5,
  Feedback = 6,
  Notes = 8,
}

export enum NotificationMessageType {
  Chat = 1,
  JobPosted = 2,
  JobAvailable = 3,
  JobWaitingApprovalPM = 4,
  JobWaitingApprovalOwner = 5,
  JobApprovedPM = 6,
  JobApprovedOwner = 7,
  QuotePlacedConsumer = 8,
  QuotePlacedProvider = 9,
  QuoteAcceptedConsumer = 10,
  QuoteAcceptedProvider = 11,
  QuoteAcceptedPM = 12,
  JobCompletedConsumer = 13,
  JobCompletedProvider = 14,
  JobCompletedPM = 15,
  QuoteRejected = 16,
  ProviderOnTheWay = 17,
  ProviderArrived = 18,
  TaskUpdated = 19,
  QuoteFeedbackProvided = 20,
  QuoteFeedbackReceived = 21,
  JobApprovalRejected = 22,
  JobPostedPM = 23,
  QuotePlacedPM = 24,
  JobPostedTenant = 25,
  QuoteFeedbackProvidedPM = 26,
  ShareSchedule = 27,
  VideoCall = 28,
  MarketPlaceSearch = 29,
  RevisedQuoteAvailable = 30,
  JobVariationAvailable = 31,
  JobVariationAccepted = 32,
  JobVariationRejected = 33,
  JobCompletedByProvider = 34,
  JobReviewAccepted = 35,
  JobReviewRejected = 36,
  JobScheduledByProvider = 37,
  QuoteRevisionRequested = 38,
  ScheduledJobNotification = 39,
  JobScheduleStatusUpdate = 40,
  InsuranceExpire = 41,
  LicenceExpire = 42,
  JobDeclined = 43,
  JobOwnerApprovalReminder = 44,
  JobAssignedToSubTrade = 45,
  VideoMessage = 46,
  Conversation = 47,
  UserHasNotSignedup = 48,
  PropertyInspectionScheduled = 49,
  PropertyInspectionScheduleStatusUpdate = 50,
  PropertyInspectionReminder = 51,
  ScheduledEventReminder = 52,
  DirectNotification = 53,
  ScheduledJobConfirmedByPm = 54,
  ResetPasswordSuccess = 55,
  UserWaitingApprovalSuperAdmin = 56,
  InspectionCall = 57,
  SuperAdminReVerificationEmail = 58,
  NewInspectionDateProposed = 59,
  PropertyInspectionReportGenerated = 60,
  RecurringJobDueToFinished = 61,
  PropertyInspectionDraftJobReminder = 62,
  Common = 63,
  ReminderToEnterCard = 64,
  DataImportCompletion = 65,
  PropertyInspectionReportGeneratedForUser = 66,
  PropertyInspectionScheduleReminder = 67,
  PropertyInspectionDelay = 68,
  PMStartInspectionNotification = 69,
  DraftedJobPostedByPm = 70,
  ProviderJobAssignedNotification = 71,
  PayerChanged = 72,
  PayerAssigned = 73,
  InvoiceReceived = 74,
  JobCompletePaymentFailure = 75,
  MissedVideoCall = 76,
  MissedChat = 81,
  JobSnoozeExpired = 89,
  JobSnoozeExpiring = 90,
  PersonalEventUpdated = 93,
  PersonalEventCancelled = 94,
  SiteVisitAssigned = 101,
  TimeLinePropertyReport = 104,
  TimeLineJobReport = 105,
  PlasedBidSiteVisit = 107,
  RecurringJobStartingTomorrow = 111,
  PropertyInspectionInviteOwner = 113,
  PropertyInspectionOwnerApproved = 114,
  PropertyInspectionOwnerReject = 115,
  PropertyInspectionReviseSchedule = 116,
  OwnersRequiredInspection = 119,
  OwnersNotifiedInspection = 120,
  PmOnTheWayForTheInspection = 122,
  ProviderAccountsMerged = 123,
  RecurringInspectionScheduleCancellation = 124,
  RecurringJobCreated = 125,
  PropertyInspectionDraftedJobList = 126,
  TradeRequestedAccessLock = 127,
  TradeUnlockProperty = 128,
  TenantRequestAccessLock = 129,
  TimeLineEmailPDF = 130,
  TimeLineJobNotePDF = 131,
  ExternallyAwarded = 132,
  OwnerApprovalPecentageUpdated = 133,
  SubcontractorCheckIn = 134,
  SubcontractorCheckOutOrComplete = 135,
  JobEstimationUpdated = 136,
  OmniTenantAskQuestion = 137,
  PmSwitchFromLiteToPremiumVersion = 138,
  TroubleshootGuide = 139,
  MergedJob = 140,
  PropertyLockAccessGrantedForTrade = 141,
  PropertyLockAccessRejectedForTrade = 142,
  PropertyLockAccessRevokedForTrade = 143,
  OrganizationInspectionLabelTextChanged = 144,
  OrganizationInspectionLabelTextAdded = 145,
  OrganizationInspectionLabelTextDeleted = 146,
  PropertyLockAccessGrantedForTradeByTenant = 147,
  PropertyLockAccessRejectedForTradeByTenant = 148,
  ScheduleUpdateCheckInTime = 149,
  QuoteLater = 150,
  PropertyLockAccessPinRequestedByTenant = 151,
  PropertyLockAccessPinRequestedByTrade = 152,
  PropertyLockAccessPinGrantedForTrade = 153,
  PropertyLockAccessPinGrantedForTenant = 154,
  PropertyLockAccessPinRejectedForTrade = 155,
  PropertyLockAccessPinRejectedForTenant = 156,
  OmniQAndASendAnswerToTenant = 157,
  PropertyAssetJobReminder = 158,
  SPQuoteCancellation = 159,
  ResendJobSingle = 361,
  ResendJobMultiple = 362,
  ResendJobWorkOrder = 363,
  IncomingEmail = 369,
  ReplyEmail = 370,
  JobNoteReminder = 374,
}

export enum DocumentCollectionType {
  jobAudit = 10,
  propertyAudit = 20,
  quoteAudit = 30,
  userAudit = 40,
  serviceProviderAudit = 50,
  organizationAudit = 60,
}
export enum TenantTypes {
  All = 0,
  PrimaryTenant = 1,
  SecondaryTenant = 2,
}
